<template>
<div>
    <v-card>
        <v-card-text>
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 sm6>
                        <table>
                            <tr>
                                <th>ОГРН</th>
                                <td>{{item.ogrn}}</td>
                            </tr>
                            <tr>
                                <th>Наименование</th>
                                <td>{{item.name}}</td>
                            </tr>
                            <tr>
                                <th>Сокращенное наименование</th>
                                <td>{{item.name_short}}</td>
                            </tr>
                            <tr>
                                <th>Дата начала</th>
                                <td>{{ item.date_begin|date_time }}</td>
                            </tr>
                            <tr>
                                <th>Дата окончания</th>
                                <td>{{ item.date_end|date_time }}</td>
                            </tr>
                        </table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
export default {
  name: 'departmentForm',
  props: {
    item: Object
  }
}

</script>

<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
